/**
* LanguageContextManager.js
* 
* Created on 14-mei-2014, 13:37:41
*
* @author Ivo Swartjes for Ranj
**/

const LanguageContextTypes = {};
export default LanguageContextTypes;

LanguageContextTypes.TYPE_NPC_TEXT = "TYPE_NPC_TEXT";
LanguageContextTypes.TYPE_DIALOG_OPTION = "TYPE_DIALOG_OPTION";
LanguageContextTypes.TYPE_DECISION_OPTION = "TYPE_DECISION_OPTION";